import axios, { type AxiosInstance } from 'axios';

import { APP_ENV } from '@/config/env';

/**
 * Plain client with no auth interceptors.
 * Refresh and logout must stay off axiosInstance, or a 401 would refresh again.
 * baseURL matches axiosInstance so a missing trailing slash still joins the path.
 */
export const createPublicAxios = (): AxiosInstance =>
    axios.create({
        baseURL: APP_ENV.VITE_API_BASE_URL || '/api',
        timeout: 30000,
        headers: {
            'Content-Type': 'application/json',
            'ngrok-skip-browser-warning': 'true'
        }
    });

const publicAxios = createPublicAxios();

export default publicAxios;
